module.exports = __webpack_public_path__ + "static/media/ovo-logo-symbol.36885dde.png";